import { Box, Flex, Grid, GridItem, Image, Input, Text, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, FormControl, FormLabel, Button, Spinner, Center, Tooltip, IconButton, } from "@chakra-ui/react";
import MyDiv from "./balanceLeave.style";
import { EditIcon } from "@chakra-ui/icons";
import { CustomButton, CustomToast } from "../../../../components";
import { useState, useEffect } from "react";
import PlusIcon from "../../../../assets/images/Vector.svg";
import { IBalanceLeave } from "./model";
import { useFetch } from "../../../../hooks/useFetch";
import CustomTables, { Column, ILazyParams } from "../../../../components/CustomTable/CustomTables";
import { showDate } from "../../../../utilities/helper";

const BalanceLeave = () => {
  const { addToast } = CustomToast();
  const { fetchApi, loading } = useFetch(addToast);
  const [balanceLeave, setBalanceLeave] = useState<IBalanceLeave[]>([]);
  const [DrawerOpen, setDrawerOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [isEditMode, setIsEditMode] = useState(false);
  const [CurrentBalanceLeave, setCurrentBalanceLeave] = useState({ id: 0, employeeId: 0, employeeName: "", yearMonth: "", balanceEL: 0, balanceCL: 0, });

  const [dataLoading, setDataLoading] = useState(false);
  const [lazyParams, setLazyParams] = useState<ILazyParams>({
    first: 0, rows: 20, sortField: undefined, sortOrder: undefined,
    multiSortMeta: [], filters: {}, globalFilter: '',
  });

  useEffect(() => {
    loadBalanceLeave();
  }, [lazyParams]);

  const loadBalanceLeave = async () => {
    setDataLoading(true);
    try {
      const params = new URLSearchParams();
      params.set('first', String(lazyParams.first));
      params.set('rows', String(lazyParams.rows));
      if (lazyParams.sortField) params.set('sortField', lazyParams.sortField);
      if (lazyParams.sortOrder) params.set('sortOrder', String(lazyParams.sortOrder));
      if (lazyParams.globalFilter) params.set('globalFilter', lazyParams.globalFilter);
      if (lazyParams.filters && Object.keys(lazyParams.filters).length) {
        params.set('filters', JSON.stringify(lazyParams.filters));
      }

      const response = await fetchApi<any>(`Hrlense_BalanceLeave?${params.toString()}`, "GET");

      console.log('BalanceLeave raw response:', response);

      if (response) {
        const rawList: any[] = Array.isArray(response) ? response : (response.data ?? response.balanceLeaves ?? []);
        const normalized: IBalanceLeave[] = rawList.map((row: any) => ({
          id: row.id ?? row.Id,
          employeeId: row.employeeId ?? row.EmployeeId,
          employeeName: row.employeeName ?? row.EmployeeName,
          yearMonth: row.yearMonth ?? row.YearMonth,
          balanceEL: row.balanceEL ?? row.BalanceEL,
          balanceCL: row.balanceCL ?? row.BalanceCL,
        }));

        setBalanceLeave(normalized);
        setTotalCount(response.totalRecords ?? response.totalCount ?? normalized.length ?? 0);
      }
    } catch (error) {
      console.error("Failed to fetch balance leaves:", error);
    }
    setDataLoading(false);
  };

  const handleAddNewBalanceLeave = () => {
    setIsEditMode(false);
    setCurrentBalanceLeave({
      id: 0,
      employeeId: 0,
      employeeName: "",
      yearMonth: "",
      balanceEL: 0,
      balanceCL: 0,
    });
    setDrawerOpen(true);
  };

  const handleEditBalanceLeave = (balanceleave: IBalanceLeave) => {
    setDrawerOpen(true);
    setIsEditMode(true);
    setSelectedId(balanceleave.id);
    setCurrentBalanceLeave(balanceleave);
  };

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    if (name === "employeeName" && !/^[A-Za-z\s]*$/.test(value)) {
      return;
    }
    if ((name === "balanceEL" || name === "balanceCL") && !/^\d*$/.test(value)) {
      return;
    }
    setCurrentBalanceLeave((prev) => ({
      ...prev, [name]: value,
    }));
  };

  const handleSubmit = async () => {
    if (!CurrentBalanceLeave.employeeName.trim()) {
      addToast({ message: "Please enter Employee Name", status: "warning" });
      return;
    }
    if (!CurrentBalanceLeave.yearMonth) {
      addToast({ message: "Please select Month/Year", status: "warning" });
      return;
    }
    if (!CurrentBalanceLeave.balanceEL.toString().trim()) {
      addToast({ message: "Please enter Balance EL", status: "warning" });
      return;
    }
    if (!CurrentBalanceLeave.balanceCL.toString().trim()) {
      addToast({ message: "Please enter Balance CL", status: "warning" });
      return;
    }

    if (isEditMode) {
      const response = await fetchApi(`Hrlense_BalanceLeave/${CurrentBalanceLeave.id}`, "PUT",
        {
          id: CurrentBalanceLeave.id,
          employeeId: CurrentBalanceLeave.employeeId,
          balanceEL: CurrentBalanceLeave.balanceEL,
          balanceCL: CurrentBalanceLeave.balanceCL,
          yearMonth: CurrentBalanceLeave.yearMonth,
        },
        null, "Balance Leave updated successfully"
      );
      if (response) await loadBalanceLeave();
    } else {
      const response = await fetchApi<IBalanceLeave>("Hrlense_BalanceLeave", "POST",
        {
          employeeId: CurrentBalanceLeave.employeeId,
          employeeName: CurrentBalanceLeave.employeeName,
          balanceEL: CurrentBalanceLeave.balanceEL,
          balanceCL: CurrentBalanceLeave.balanceCL,
          yearMonth: CurrentBalanceLeave.yearMonth,
        },
        null, "Balance Leave added successfully"
      );
      if (response) await loadBalanceLeave();
    }
    setDrawerOpen(false);
  };

  return (
    <MyDiv>
      <Box position="relative" minH="300px">
        <>
          <Flex className="page_heading flex_header">
            <Text className="font-poppins text_semibold text_3xl">Balance Leave</Text>
            <Flex gap={2}>
              <CustomButton title="Add Balance Leave" className=" btn font-poppins text_sm text_medium" rightIcon={<Image src={PlusIcon} className="logo" />} onClick={handleAddNewBalanceLeave} />
            </Flex>
          </Flex>

          <Grid className="grid_container">
            <GridItem colSpan={12}>
              <CustomTables<IBalanceLeave>
                value={balanceLeave} loading={dataLoading} emptyMessage="No Data Available" preferenceKey="balanceLeaveTable" globalSearchPlaceholder="Search By Employee..."
                lazy lazyParams={lazyParams} onLazyParamsChange={setLazyParams} totalRecords={totalCount}
                showPagination rowsPerPageOptions={[20, 100, 200, 500]} maxTableHeight={null}
              >
                <Column header="S. No" body={(_, index) => lazyParams.first + index + 1} />
                <Column header="Employee Name" field="employeeName" sortable filterable filterType="text" />
                <Column header="Year Month" field="yearMonth" sortable filterable filterType="date" body={(row: any) => row.yearMonth ? showDate(row.yearMonth) : "N/A"} />
                <Column header="Balance EL" field="balanceEL" sortable />
                <Column header="Balance CL" field="balanceCL" sortable />
                <Column header="Action" frozen="right" body={(bl: any) => (
                  <Tooltip label="Edit Balance Leave" hasArrow>
                    <IconButton aria-label="Edit" icon={<EditIcon />} size="sm" colorScheme="orange" variant="ghost" onClick={() => handleEditBalanceLeave(bl)} />
                  </Tooltip>
                )}
                />
              </CustomTables>
            </GridItem>
          </Grid>
        </>
      </Box>

      <Drawer isOpen={DrawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="sm">
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader borderBottomWidth="1px">{isEditMode ? "Edit Balance-Leave" : "Add New Balance-Leave"}</DrawerHeader>
          <DrawerBody display="flex" flexDirection="column" justifyContent="space-between" height="100%">
            <Box py={4}>
              <FormControl mb={4} isRequired>
                <FormLabel>Employee Name</FormLabel>
                <Input name="employeeName" value={CurrentBalanceLeave.employeeName} onChange={handleInputChange} placeholder="Enter Employee Name" />
              </FormControl>
              <FormControl mb={4} isRequired>
                <FormLabel>Month/Year</FormLabel>
                <Input type="date" name="yearMonth" value={CurrentBalanceLeave.yearMonth} onChange={handleInputChange} placeholder="Enter Date"
                  min={new Date().toISOString().split("T")[0]}
                />
              </FormControl>
              <FormControl mb={4} isRequired>
                <FormLabel>Balance EL</FormLabel>
                <Input name="balanceEL" value={CurrentBalanceLeave.balanceEL} onChange={handleInputChange} placeholder="Enter Balance EL"
                />
              </FormControl>
              <FormControl mb={4} isRequired>
                <FormLabel>Balance CL</FormLabel>
                <Input name="balanceCL" value={CurrentBalanceLeave.balanceCL} onChange={handleInputChange} placeholder="Enter Balance CL"
                />
              </FormControl>
            </Box>
            <Flex justify="flex-end" mt={4} gap={2}>
              <Button className="font-poppins text_sm text_medium" onClick={() => setDrawerOpen(false)} style={{ backgroundColor: "#D92F34", color: "white" }}
              >
                Cancel
              </Button>
              <Button onClick={handleSubmit} className="font-poppins text_sm text_medium" style={{ backgroundColor: "#006838", color: "white" }}
              >
                {isEditMode ? "Update Balance-Leave" : "Add Balance-Leave"}
              </Button>
            </Flex>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </MyDiv>
  );
};

export default BalanceLeave;